import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskMarkedUrgent_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from '../../Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskMarkedUrgent_ActivityLogFragment;
}

const ActivityLogTaskMarkedUrgent: FCWithFragments<Fragments> = ({ activityLog }) => {
  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.markedUrgent"
    />
  );
};

ActivityLogTaskMarkedUrgent.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskMarkedUrgent_activityLog on ActivityLog {
      id

      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskMarkedUrgent;
